<template>
  <div class="collection-details">
    <module-title title="收款明细"></module-title>
    <el-table :data="data" style="width: 100%">
      <el-table-column prop="outTradeNo" label="支付流水号"></el-table-column>
      <el-table-column label="交易类型">
        <template v-slot="scope">
          {{ scope.row.payType | formatPayType }}
        </template>
      </el-table-column>
      <el-table-column label="支付时间" align="center">
        <template v-slot="scope">
          <span>{{ scope.row.gmtPayment | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付金额(元)" align="center">
        <template v-slot="scope">
          <span>{{ scope.row.paymentAmount | currencyFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="付款账号/付款银行" align="center">
        <template v-slot="scope">
          <span v-if="scope.row.payerBankNo">{{ scope.row.payerBankNo }}/</span>
          <span v-if="scope.row.payerBankName">{{ scope.row.payerBankName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="receiverBankNo" label="收款账号/收款银行" align="center">
        <template v-slot="scope">
          <span v-if="scope.row.receiverBankNo">{{ scope.row.receiverBankNo }}/</span>
          <span v-if="scope.row.receiverBankName">{{ scope.row.receiverBankName }}</span>
        </template>
      </el-table-column>
      <el-table-column label="支付类型" align="center">
        <template v-slot="scope">{{ scope.row.payChannel | formatPayChannel }}</template>
      </el-table-column>
      <el-table-column label="回执单据" align="center">
        <template v-slot="scope">
          <el-button
            v-if="scope.row.outTradeCertificate && scope.row.outTradeCertificate.length > 0"
            type="text"
            @click="preview(scope.row.outTradeCertificate)"
            >查看凭证</el-button
          >
          <el-button
            v-if="scope.row.tradeCertificate"
            type="text"
            @click="preview(scope.row.tradeCertificate)"
            >查看回单</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <preview-dialog :visible.sync="visiblePreview" :data="previewData"></preview-dialog>
  </div>
</template>

<script>
import ModuleTitle from '@/components/module-title'
import PreviewDialog from './preview-dialog'
import preview from '@/common/utils/preview'
import { isImage } from '@/common/utils/validate'
import { download } from '@/common/utils/download'

const PAY_TYPE = {
  ['1']: '交易订单',
  ['2']: '订单补款',
  ['3']: '记账订单-补款',
  ['4']: '记账订单-退款'
}

const PAY_CHANNEL = {
  ['1']: 'B2B网关支付',
  ['2']: '招行线下支付',
  ['3']: '线下支付',
  ['4']: '赊销',
  ['5']: '招行担保支付'
}

export default {
  name: 'CollentionDetails',
  components: { ModuleTitle, PreviewDialog },
  props: {
    data: Array
  },
  data() {
    return {
      visiblePreview: false,
      previewData: [],
      clickcount: 0
    }
  },
  filters: {
    formatPayType(payType) {
      return PAY_TYPE[String(payType)] ? PAY_TYPE[String(payType)] : ''
    },
    formatPayChannel(type) {
      return PAY_CHANNEL[String(type)] ? PAY_CHANNEL[String(type)] : ''
    }
  },
  beforeDestroy() {
    preview.previewDestroy()
  },
  methods: {
    preview(views) {
      if (Array.isArray(views)) {
        const notImage = views.find(ele => !isImage(ele))
        if (notImage) {
          this.previewData = views
          this.visiblePreview = true
        } else {
          preview.previewImage(views)
        }
      } else {
        if (isImage(views)) {
          preview.previewImage(views)
        } else {
          download(views)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.collection-details {
  /deep/ .el-table {
    border: 1px solid #f0f0f0;
    &::before {
      height: 0;
    }
    th.is-leaf {
      background: #f8f8f8;
      font-size: 12px;
      color: #999999;
      border: none;
    }
    tr:last-child {
      td {
        border: none;
      }
    }
    td {
      border-color: #f0f0f0;
    }
  }
}
</style>
